var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full mt-10 flex"},[_c('div',{staticClass:"w-1/3 p-4 border rounded border-gray-500 container m-auto"},[_c('ChangePassword')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }